module.exports = __webpack_public_path__ + "img/city-with-infopoints.c3b87d87.png";